<div class="plugin-form">

  <p class="plugin-section-title">Cloud Provider</p>

  <!-- Provider image selector -->
  <div class="provider-grid">
    <div *ngFor="let cp of cloudOptions"
         class="provider-img"
         [class.selected]="selectedCloudProvider === cp.id"
         (click)="selectCloudProvider(cp.id)">
      <img src="../../../../../assets/images/resources/cloudprovider/{{cp.id}}.png"
           [alt]="cp.name" class="provider-thumb">
    </div>
  </div>

  <!-- Region -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Region</mat-label>
    <input matInput [matAutocomplete]="regionAuto"
      [(ngModel)]="regionSearch"
      (ngModelChange)="filterRegions($event)"
      placeholder="Search region…">
    <mat-autocomplete #regionAuto (optionSelected)="onRegionSelected($event.option.value)">
      <mat-option *ngFor="let r of filteredRegions" [value]="r">{{ r.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Size -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Size</mat-label>
    <input matInput [matAutocomplete]="sizeAuto"
      [(ngModel)]="sizeSearch"
      (ngModelChange)="filterSizes($event)"
      placeholder="Search size…">
    <mat-autocomplete #sizeAuto (optionSelected)="onSizeSelected($event.option.value)">
      <mat-option *ngFor="let s of filteredSizes" [value]="s">{{ s.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Storage -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Storage</mat-label>
    <input matInput [matAutocomplete]="storageAuto"
      [(ngModel)]="storageSearch"
      (ngModelChange)="filterStorages($event)"
      placeholder="Search storage type…">
    <mat-autocomplete #storageAuto (optionSelected)="onStorageSelected($event.option.value)">
      <mat-option *ngFor="let st of filteredStorages" [value]="st">{{ st.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

</div>
